import { type ApiResponse, FmsApi, type iMessageSendParams, type MessageSendResponse } from "../fmsapi"
import BaseController from "./base"

export class MessageController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "message")
  }

  public async send(params: iMessageSendParams): Promise<MessageSendResponse> {
    return await this.callApi("send", params)
  }

  public async send_message(params: {
    title: string
    fair_visitor_id: string
    templatecode: string
    receiveMobileNumber: string[]
    callBack: string
    sender: string
    fair_master_id: string
    button: string
    senderkey: string
    message: string
  }): Promise<ApiResponse> {
    return await this.callApi("send_message", params)
  }
}
